module.exports = __webpack_public_path__ + "img/about-us-heating.7ba4f574.webp";